import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useContext, useMemo } from 'react';
import { useEditingProps, useGetZ3kObject } from '../utils/unpack-props';
import { Command, GuardZone, TMKey } from 'z3k-config';
import { MaterialReadOnly } from 'console/shared/components/fields';
import { ErrorBoundary } from 'shared/components/error-boundary';
import { useBox, usePartial } from 'shared/hooks/utils';
import { select_guard_zone_and_output_action_options } from 'z3k-parser/lib/z3k-selectors';
import { SettingFullRow } from 'console/device-settings/z3k/components/material-utils/settings-card/full-row';
import { SettingContainer } from 'console/device-settings/z3k/components/material-utils/settings-card/container';
import { Z3KSettingsEditor } from 'console/device-settings/z3k/provider/types';
import { Control } from 'console/shared/components/fields/control';
import { TextInputWrapper } from 'console/shared/components/fields/text';
import { MultipleSelectionTable, } from 'z3k-settings/components/material-utils/multiple-selection-table/multiple-selection';
export const TMKeyControl = memo(function TMKeyControlImpl() {
    const z3k_name = 'tm_keys';
    const item = useGetZ3kObject(z3k_name);
    const id = item.id;
    const { replace_config, config } = useContext(Z3KSettingsEditor);
    const touch_action_options = select_guard_zone_and_output_action_options(config);
    const multipleSelectionTableOptions = useMemo(() => {
        const result = [
            {
                title: 'Список действий при касании ключа',
                help_id: 'tm_keys_touch_actions',
                z3k_field: 'touch_actions',
                options: touch_action_options,
            },
        ];
        return result;
    }, [item, touch_action_options]);
    const configBox = useBox(config);
    const convertAndSetTouchActions = useCallback((tm_key, touch_actions) => {
        let new_config = configBox.current;
        const result = touch_actions.map((action_id) => {
            const guard_zone = GuardZone.get.byId(configBox.current, action_id);
            if (guard_zone == null) {
                return action_id;
            }
            let new_id;
            [new_id, new_config] = Command.get.add(new_config, {
                name: `Управлять охранной зоной «${guard_zone.name}»`,
                objectid: guard_zone.id,
                cmd: '2',
            });
            return new_id;
        });
        replace_config(TMKey.get.applySetterById(new_config, tm_key.id, {
            touch_actions: result,
        }));
    }, [replace_config]);
    const nameEditingProps = useEditingProps(id, z3k_name, 'name');
    const _convertAndSetTouchActions = usePartial(convertAndSetTouchActions, item);
    return (_jsx(ErrorBoundary, { children: _jsxs(SettingContainer, { children: [_jsx(Control, { label: "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435", field: TextInputWrapper, help_id: "tm_keys_name", ...nameEditingProps }), _jsx(MaterialReadOnly, { alignTop: false, label: "\u0421\u0435\u0440\u0438\u0439\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440", value: item.serial, help_id: "tm_keys_serial", show_copy: true }), _jsx(SettingFullRow, { children: _jsx(MultipleSelectionTable, { elements: multipleSelectionTableOptions, z3k_name: z3k_name, notification: false, onChange: _convertAndSetTouchActions }) })] }) }));
});
